import { render, staticRenderFns } from "./PpeApplyRecordDetailList.vue?vue&type=template&id=023d90a5&"
import script from "./PpeApplyRecordDetailList.vue?vue&type=script&lang=js&"
export * from "./PpeApplyRecordDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports